/**
 * 用户信息定义和同步
 * @author chenqunfeng
 * @since 2018-10-11
 */

import clone from '@fe/common/lib/clone';
import { SET_USER_INFO } from 'constants/action.json5';
import { getOrgPackage } from 'api/user';
import { getKdtId } from 'api/opf';
import * as qs from '@fe/common/lib/query-string';
import toast from 'components/toast';

export function setUserInfo(info) {
  return async dispatch => {
    try {
      let userInfo = clone(info, true);

      if (!userInfo || !userInfo.userId) {
        dispatch({
          type: SET_USER_INFO,
          data: { guest: true },
        });
      } else {
        let orgPackage = null;
        let kdtId = null;
        userInfo.organizeId = userInfo.userOrganize;
        userInfo.organizationId = userInfo.userMkOrganize;
        delete userInfo.userOrganize;
        delete userInfo.userMkOrganize;
        if (userInfo.organizeId) {
          orgPackage = await getOrgPackage(userInfo.organizeId);
        }
        // iframe并且链接带有from字段，去获取kdtId
        if (window.top !== window && qs.parse(window.location.search)['from']) {
          try {
            kdtId = await getKdtId();
            if (kdtId) {
              userInfo.kdtId = kdtId;
              userInfo.isYouzan = true;
            } else {
              toast.show({
                type: 'error',
                msg:
                  '为了保证您能顺利完成付款，请到兔展用户中心切换身份到您的该有赞店铺下',
              });
            }
          } catch (e) {
            console.log(e);
          }
        }
        dispatch({
          type: SET_USER_INFO,
          data: {
            ...userInfo,
            ...orgPackage,
            guest: false,
          },
        });
      }
    } catch (err) {
      console.log(err, 'err');
      dispatch({
        type: SET_USER_INFO,
        data: { guest: true },
      });
    }
  };
}

export function setGuestInfo() {
  return async dispatch => {
    dispatch({
      type: SET_USER_INFO,
      data: { guest: true },
    });
  };
}
